import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    // Auth
    welcome: "Welcome",
    signIn: "Sign In",
    signUp: "Sign Up",
    email: "Email",
    password: "Password",
    fullName: "Full Name",
    role: "Role",
    owner: "Owner",
    manager: "Manager",
    login: "Login",
    register: "Register",
    noAccount: "Don't have an account?",
    haveAccount: "Already have an account?",
    
    // Navigation
    overview: "Overview",
    myProperties: "My Properties",
    properties: "Properties",
    expenses: "Expenses",
    maintenance: "Maintenance",
    visualInventory: "Visual Inventory",
    aiInventory: "AI Inventory",
    reports: "Reports",
    managers: "Managers",
    aiValuation: "AI Valuation",
    marketData: "Market Data",
    subscription: "Subscription",
    aiCFO: "AI CFO",
    logout: "Logout",
    
    // Dashboard
    controlTower: "Control Tower",
    propertyIntelligence: "AI-Powered Property Intelligence",
    operatingBalance: "Operating Balance",
    monthlyExpenses: "Monthly Expenses",
    netOperatingIncome: "Net Operating Income",
    propertyHealth: "Property Health",
    
    // Inventory
    totalInventoryValue: "Total Inventory Value",
    items: "items",
    goodCondition: "Good Condition",
    needsAttention: "Needs Attention",
    itemsToReview: "items to review",
    viewInventory: "View Inventory",
    itemsNeedingAttention: "Items Needing Attention",
    needsReplacement: "Needs replacement",
    poorCondition: "Poor condition",
    
    // CFO Dashboard
    aiPropertyCFO: "AI Property CFO",
    completeFinancialControl: "Complete financial control of your property",
    addIncome: "Add Income",
    configure: "Configure",
    totalExpenses: "Total Expenses",
    cashFlow: "Cash Flow",
    annualROI: "Annual ROI",
    margin: "Margin",
    bookings: "bookings",
    propertyValue: "Property Value",
    
    // Budget
    smartBudgetAutopilot: "Smart Budget Autopilot",
    annualBudget: "Annual Budget",
    used: "used",
    remaining: "Remaining",
    projectedAnnual: "Projected Annual",
    monthlyBudgetRemaining: "Monthly budget remaining",
    budgetOnTrack: "Budget on track",
    budgetExceeded: "Budget exceeded!",
    
    // Reports
    reportHistory: "Report History",
    generateAndManageReports: "Generate and manage all your financial and inventory reports",
    financialPDF: "Financial PDF",
    financialExcel: "Financial Excel",
    sale: "Sale",
    allReports: "All",
    noReports: "No reports",
    generateFirstReport: "Generate your first report using the buttons above",
    totalReports: "Total Reports",
    
    // Subscription
    subscriptionPlans: "Subscription Plans",
    choosePerfectPlan: "Choose the perfect plan to manage your luxury properties with AI",
    yourPlan: "YOUR PLAN",
    subscribe: "Subscribe",
    currentPlan: "Current Plan",
    cancelSubscription: "Cancel Subscription",
    planActive: "Plan Active",
    subscriptionActive: "Your subscription is active",
    
    // Plans
    basicPlan: "Basic",
    basicDescription: "Basic control of your property",
    proPlan: "Pro",
    proDescription: "Intelligent control with AI",
    premiumPlan: "Premium",
    premiumDescription: "Complete management suite",
    
    // Features
    oneProperty: "1 Property",
    upTo3Properties: "Up to 3 Properties",
    unlimitedProperties: "Unlimited Properties",
    expenseTracking: "Expense tracking",
    basicInventory: "Basic inventory",
    financialReports: "Financial reports PDF/Excel",
    aiPropertyCFOFeature: "AI Property CFO",
    smartBudgetFeature: "Smart Budget Autopilot",
    aiValuationFeature: "AI Valuation",
    visualInventoryAI: "Visual Inventory with AI",
    insuranceReports: "Insurance Reports",
    aiPropertyAdvisor: "AI Property Advisor",
    vendorNetwork: "Vendor Network",
    rentalOptimization: "Rental Optimization",
    prioritySupport: "Priority Support",
    apiAccess: "API Access",
    
    // AI Assistant
    aiInventoryAssistant: "AI Inventory Assistant",
    analyzeInventoryWithAI: "Analyze and understand your inventory with artificial intelligence",
    askAboutInventory: "Ask about your inventory...",
    quickQuestions: "Quick Questions",
    needsReplacementQ: "What items need replacement soon?",
    conditionSummary: "Give me a summary of the general condition",
    highestValueCategory: "Which categories have the highest value?",
    mostValuableItems: "What are the most valuable items?",
    recommendImprovements: "Recommend improvements for inventory",
    inventorySummary: "Inventory Summary",
    locations: "Locations",
    aiDetected: "AI Detected",
    byCondition: "By Condition",
    excellent: "Excellent",
    good: "Good",
    fair: "Fair",
    poor: "Poor",
    
    // Common
    loading: "Loading...",
    error: "Error",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    download: "Download",
    generate: "Generate",
    refresh: "Refresh",
    filter: "Filter",
    search: "Search",
    noData: "No data",
    selectedProperty: "Selected Property",
    name: "Name",
    location: "Location",
    health: "Health",
    ticketsAndTasks: "Tickets and tasks",
    pdfExcelReports: "PDF, Excel reports",
    
    // Month abbreviations
    jan: "Jan",
    feb: "Feb",
    mar: "Mar",
    apr: "Apr",
    may: "May",
    jun: "Jun",
    jul: "Jul",
    aug: "Aug",
    sep: "Sep",
    oct: "Oct",
    nov: "Nov",
    dec: "Dec",
    
    // Visual Inventory
    aiPoweredInventory: "AI-powered property inventory with photos",
    downloadReport: "Download Report",
    addLocation: "Add Location",
    newLocation: "New Location",
    locationPlaceholder: "e.g., Kitchen, Living Room, Master Bedroom",
    createLocation: "Create Location",
    uploadPhotos: "Upload Photos",
    analyzing: "Analyzing...",
    noPhotosYet: "No photos yet. Upload photos to start inventory.",
    photoDetails: "Photo Details",
    category: "Category",
    description: "Description",
    identifiedItems: "Identified Items",
    brand: "Brand",
    type: "Type",
    condition: "Condition",
    yourNotes: "Your Notes",
    deletePhoto: "Delete Photo",
    
    // Concierge Network
    concierge: "Concierge",
    conciergeNetwork: "Concierge Network",
    connectWithProviders: "Connect with trusted service providers for your properties",
    browseVendors: "Browse Vendors",
    myQuotes: "My Quotes",
    myContracts: "My Contracts",
    searchVendors: "Search vendors...",
    categories: "Categories",
    allCategories: "All",
    noVendorsFound: "No vendors found",
    reviews: "Reviews",
    jobsCompleted: "jobs completed",
    services: "Services",
    requestQuote: "Request Quote",
    
    // Demo Modal
    liveDemo: "LIVE DEMO",
    seeVillaPilotInAction: "See VillaPilot AI in Action",
    exploreRealDemoProperty: "Explore a real demo property with 12 months of data",
    beds: "beds",
    baths: "baths",
    openControlTower: "Open Control Tower",
    controlTowerManageProperty: "Control Tower - Manage Your Property",
    allToolsNeeded: "All the tools you need to manage your luxury property",
    projections: "Projections",
    smartAlerts: "Smart alerts",
    trackIncome: "Track income",
    categorize: "Categorize",
    setBudgets: "Set budgets",
    scheduleTasks: "Schedule tasks",
    trackRepairs: "Track repairs",
    history: "History",
    photoScanning: "Photo scanning",
    aiRecognition: "AI recognition",
    damageReports: "Damage reports",
    financial: "Financial",
    resale: "Resale",
    vendorDirectory: "Vendor directory",
    requestQuotes: "Request quotes",
    monthPerformance12: "12-Month Performance",
    value: "Value",
    tryWithYourProperty: "Try It With Your Property",
    
    requestingQuoteFrom: "Requesting quote from",
    title: "Title",
    briefTitle: "Brief title for your request",
    describeWork: "Describe the work needed...",
    preferredDate: "Preferred Date",
    budgetRange: "Budget Range",
    selectBudget: "Select budget range",
    sendQuoteRequest: "Send Quote Request",
    quoteRequestSent: "Quote request sent successfully",
    failedToSendQuote: "Failed to send quote request",
    noQuotesYet: "No quotes yet. Browse vendors to request quotes.",
    quoteAmount: "Quote Amount",
    accept: "Accept",
    quoteAccepted: "Quote accepted! Contract created.",
    quoteRejected: "Quote rejected",
    failedToAcceptQuote: "Failed to accept quote",
    failedToRejectQuote: "Failed to reject quote",
    noContractsYet: "No contracts yet",
    contractAmount: "Contract Amount",
    scheduledDate: "Scheduled Date",
    payNow: "Pay Now",
    markComplete: "Mark Complete",
    paymentSuccessful: "Payment successful!",
    failedToProcessPayment: "Failed to process payment",
    contractCompleted: "Contract marked as completed",
    failedToCompleteContract: "Failed to complete contract",
    quoted: "Quoted",
    accepted: "Accepted",
    active: "Active",
    completed: "Completed",
    cancelled: "Cancelled",
    paid: "Paid",
    pendingPayment: "Pending Payment",
    
    // Marketing
    getStarted: "Get Started",
    learnMore: "Learn More",
    features: "Features",
    pricing: "Pricing",
    contact: "Contact",
    
    // Trust badges
    securePayments: "Secure payments with Stripe",
    cancelAnytime: "Cancel anytime",
    instantActivation: "Instant activation",
    
    // FAQ
    faq: "Frequently Asked Questions",
    canChangePlan: "Can I change my plan later?",
    canChangePlanAnswer: "Yes, you can upgrade or downgrade your plan at any time. Changes will apply at the start of the next billing period.",
    paymentMethods: "What payment methods do you accept?",
    paymentMethodsAnswer: "We accept all major credit and debit cards through Stripe: Visa, Mastercard, American Express.",
    moneyBackGuarantee: "Is there a free trial?",
    moneyBackGuaranteeAnswer: "Yes — every paid plan starts with a 14-day free trial. You are not charged until the trial ends, and you can cancel anytime before then at no cost.",
    
    // Navigation Labels
    calendars: "Calendars",
    inventory: "Inventory",
    selectLanguage: "Language",
    
    // Marketing/Landing Page
    heroTitle: "Property Management",
    heroSubtitle: "Reimagined with AI",
    heroDescription: "The most intelligent platform for luxury villa management. Complete operational control, financial transparency, and AI-powered insights.",
    watchDemo: "Watch Demo",
    requestDemo: "Request Demo",
    talkToSales: "Talk to Sales",
    trialNote: "14-day free trial • Secure checkout with Stripe",
    propertiesManaged: "Properties Managed",
    assetsUnderManagement: "Assets Under Management",
    customerSatisfaction: "Customer Satisfaction",
    countries: "Countries",
    howItWorks: "How it Works",
    testimonials: "Testimonials",
    
    // Control Tower - Financial KPIs
    income: "Income",
    expensesLabel: "Expenses",
    balance: "Balance",
    occupancy: "Occupancy",
    thisYear: "This year",
    profit: "Profit",
    loss: "Loss",
    annualAverage: "Annual average",
    
    // Control Tower - Charts
    months12: "12 months",
    
    // Control Tower - Quick Actions
    quickActions: "Quick Actions",
    calendar: "Calendar",
    reportsPl: "Reports",
    
    // Control Tower - Cards
    financialDashboard: "Financial dashboard",
    syncPlatforms: "Sync platforms",
    registerExpenses: "Register expenses",
    manageItems: "Manage items",
    scanWithPhotos: "Scan with photos",
    priceAlerts: "Price Alerts",
    vendorContracts: "Vendor contracts",
    providerNetwork: "Provider network",
    generatePdfExcel: "Generate PDF/Excel",
    inventoryChat: "Inventory Chat",
    
    // Property Card
    selectProperty: "Select a property to view its full Control Tower",
    bedrooms: "bedrooms",
    bathrooms: "bathrooms",
    addFirstProperty: "Add your first property",
    demoPropertyHelp: "The demo property shows you all features. Add your real villa to get started!",
    addProperty: "Add Property",
    incomeVsExpenses: "Income vs Expenses",
    monthlyOccupancy: "Monthly Occupancy",
    
    // Dashboard specific
    currentParameters: "Current Parameters",
    investmentSummary: "Investment Summary",
    estimatedValue: "Estimated Value",
    appreciation: "Appreciation",
    netIncome: "Net Income",
    
    // Vendor Tasks
    myTasks: "My Tasks",
    completedTasks: "Completed",
    
    // Calendar Sync
    calendarSync: "Calendar Sync",
    connectCalendars: "Connect your Airbnb, VRBO and other platforms calendars",
    syncAll: "Sync All",
    addCalendar: "Add Calendar",
    connectedCalendars: "Connected Calendars",
    noCalendarsConnected: "No calendars connected",
    addFirstCalendar: "Add your first calendar",
    syncedBookings: "Synced Bookings",
    upcomingBookings: "Upcoming Bookings",
    totalNights: "total nights",
    platform: "Platform",
    lastSync: "Last sync",
    syncCompleted: "Sync completed",
    blocked: "Blocked",
    booking: "Booking",
    confirmed: "Confirmed",
    night: "night",
    nights: "nights",
    addIcalCalendar: "Add iCal Calendar",
    calendarName: "Calendar name",
    icalUrl: "iCal URL",
    validateCalendar: "Validating...",
    whereToFindUrl: "Where do I find the URL?",
    airbnbHelp: "In Airbnb: Go to your Calendar → Settings (⚙️) → \"Export calendar\" → Copy the iCal link",
    
    // Expenses
    expensesAndIncome: "Expenses & Income",
    manageExpenses: "Manage and approve your property expenses",
    newExpense: "New Expense",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    pendingApproval: "Pending Approval",
    allExpenses: "All Expenses",
    vendor: "Vendor",
    amount: "Amount",
    status: "Status",
    approve: "Approve",
    reject: "Reject",
    registerNewExpense: "Register New Expense",
    selectCategory: "Select category...",
    selectSubcategory: "Select subcategory...",
    amountUSD: "Amount (USD)",
    providerVendor: "Provider / Vendor",
    providerName: "Provider name",
    expenseDescription: "Description",
    additionalDescription: "Additional expense description...",
    invoiceReceipt: "Invoice / Receipt (optional)",
    clickToUpload: "Click to upload an image or PDF",
    registerExpense: "Register Expense",
    saving: "Saving...",
    property: "Property",
    date: "Date",
    
    // Expense Subcategories
    electricity: "Electricity",
    water: "Water",
    internet: "Internet",
    gas: "Gas",
    cableTV: "Cable/TV",
    phone: "Phone",
    regularCleaning: "Regular Cleaning",
    deepCleaning: "Deep Cleaning",
    laundry: "Laundry",
    suppliesSub: "Supplies",
    ac: "A/C",
    plumbing: "Plumbing",
    electricalWork: "Electrical",
    painting: "Painting",
    general: "General",
    insurance: "Insurance",
    taxesSub: "Taxes",
    accounting: "Accounting",
    licenses: "Licenses",
    furniture: "Furniture",
    appliances: "Appliances",
    improvements: "Improvements",
    remodeling: "Remodeling",
    amenities: "Amenities",
    bathroomItems: "Bathroom Items",
    kitchen: "Kitchen",
    office: "Office",
    
    // Inventory Management
    inventoryManagement: "Inventory Management",
    manageAllItems: "Manage all items of your property",
    addItem: "Add Item",
    totalItems: "Total Items",
    totalValue: "Total Value",
    differentTypes: "different types",
    searchByName: "Search by name...",
    allCategoriesFilter: "All categories",
    sortByName: "Name",
    sortByValue: "Value",
    sortByCategory: "Category",
    noItemsFound: "No items found with those filters",
    noItemsInInventory: "No items in inventory",
    addFirstItem: "Add first item",
    quantity: "Quantity",
    unitValue: "Unit value",
    editItem: "Edit Item",
    categoryRequired: "Category",
    itemName: "Item Name",
    estimatedValueLabel: "Estimated Value ($)",
    purchaseDateOptional: "Purchase Date (optional)",
    replacementCycle: "Replacement Cycle (months)",
    replacementCycleHelp: "Estimated frequency to replace this item",
    notesOptional: "Notes (optional)",
    additionalInfo: "Additional information about the item...",
    updateItem: "Update Item",
    
    // CFO Dashboard
    registerRentalIncome: "Register Rental Income",
    source: "Source",
    directBooking: "Direct Booking",
    guestNameOptional: "Guest Name (optional)",
    checkIn: "Check-in",
    checkOut: "Check-out",
    nightlyRate: "Nightly Rate ($)",
    platformFee: "Platform Fee ($)",
    cleaningFee: "Cleaning Fee ($)",
    cfoSettings: "CFO Settings",
    estimatedPropertyValue: "Estimated Property Value ($)",
    purchasePrice: "Purchase Price ($)",
    annualMaintenanceBudget: "Annual Maintenance Budget ($)",
    budgetAlertThreshold: "Budget Alert (%)",
    budgetAlertHelp: "Receive alert when this % of budget is used",
    saveSettings: "Save Settings",
    settings: "Settings",
    incomeVsExpensesMonthly: "Monthly Income vs Expenses",
    incomeBySource: "Income by Source",
    noIncomeData: "No income data",
    expensesByCategory: "Expenses by Category",
    noExpenseData: "No expense data",
    occupancyLabel: "Occupancy",
    nightsRented: "nights rented",
    averageRate: "Average Rate",
    perNight: "per night",
    propertyValueLabel: "Property Value",
    purchase: "Purchase",
    subcategory: "Subcategory",
    confirmDeleteCalendar: "Delete this calendar and all synchronized bookings?",
    success: "Success",
    calendarDeleted: "Calendar deleted",
    deleteError: "Could not delete",
    calendarsSynced: "calendars synced",
    syncError: "Sync error",
    registerAndApprove: "Register and approve expenses",
    loadPropertiesError: "Could not load properties",
    nameUrlRequired: "Name and URL are required",
    calendarAdded: "Calendar added successfully",
    syncing: "Syncing...",
    fetchingBookings: "Fetching bookings from calendar",
    addCalendarError: "Could not add calendar",
    newBookings: "new",
    updatedBookings: "updated",
    incomeRegistered: "Income registered successfully",
    incomeRegisterError: "Could not register income",
    settingsUpdated: "Settings updated",
    settingsUpdateError: "Could not update settings",
    updateExpenseError: "Failed to update expense",
    expense: "Expense",
    pdfDownloaded: "PDF report downloaded",
    pdfGenerateError: "Failed to generate PDF",
    excelDownloaded: "Excel report downloaded",
    excelGenerateError: "Failed to generate Excel",
    
    // Vendor Contracts Page
    vendorContractsTitle: "Vendor Contracts",
    vendorContractsDescription: "Manage vendor contracts and get alerts if you are overcharged",
    contracts: "Contracts",
    alerts: "Alerts",
    activeAlerts: "active alerts",
    potentialOvercharge: "Potential total overcharge",
    viewAlerts: "View alerts",
    addContract: "Add Contract",
    noContractsRegistered: "No contracts registered",
    registerContractsHelp: "Register agreed prices with your vendors to get alerts if you are overcharged",
    addFirstContract: "Add first contract",
    perService: "service",
    perHour: "hour",
    perMonth: "month",
    validUntil: "Valid until",
    noActiveAlerts: "No active alerts",
    allExpensesWithinPrices: "All expenses are within agreed vendor prices",
    charged: "Charged",
    expected: "Expected",
    excess: "excess",
    recommendation: "Recommendation",
    newContract: "New Contract",
    vendorNameLabel: "Vendor Name",
    vendorNamePlaceholder: "E.g.: John Doe Cleaning",
    categoryLabel: "Category",
    typeLabel: "Type",
    quote: "Quote",
    contract: "Contract",
    invoice: "Invoice",
    agreedRates: "Agreed Rates",
    perServiceRate: "Per Service",
    hourlyRate: "Per Hour",
    monthlyRate: "Monthly",
    descriptionLabel: "Description",
    serviceDetails: "Service details...",
    validUntilLabel: "Valid Until",
    cancelButton: "Cancel",
    saveContract: "Save Contract",
    contractSaved: "Contract saved",
    contractSavedDesc: "The vendor contract has been saved successfully",
    contractDeleted: "Contract deleted",
    deleteContract: "Delete this contract?",
    alertDismissed: "Alert dismissed",
    
    // Categories
    cleaning: "Cleaning",
    maintenanceCat: "Maintenance",
    pool: "Pool",
    garden: "Garden",
    utilities: "Utilities",
    other: "Other",
    
    // Report types
    financialReportPdf: "Financial Report PDF",
    financialReportExcel: "Financial Report Excel",
    visualInventoryReport: "Visual Inventory",
    insuranceReport: "Insurance Report",
    saleReport: "Sale Report",
    downloaded: "Downloaded",
    deleted: "Deleted",
    reportDeletedFromHistory: "Report deleted from history",
    deleteReportConfirm: "Are you sure you want to delete this report?",
    
    // Demo banner
    demoBanner: "This is a demo property with 1 year of data. Explore all the features that VillaPilot AI offers to manage your properties!",
    
    // Charts
    incomeSources: "Income Sources",
    expenseBreakdown: "Expense Breakdown",
    recentExpenses: "Recent Expenses",
    viewAll: "View all",
    noRecentExpenses: "No recent expenses",
    upcomingBookingsLabel: "Upcoming Bookings",
    noUpcomingBookings: "No upcoming bookings",
    startRecordingData: "Start recording data",
    chartsAppearWhen: "Charts will appear when you register income, expenses or connect your Airbnb/VRBO calendars.",
    registerIncome: "Register Income",
    connectCalendar: "Connect Calendar",
    loadingData: "Loading data...",
    annualIncome: "Annual Income",
    annualExpenses: "Annual Expenses",
    annualNetIncome: "Annual Net Income",
    
    // Open Controls
    openControls: "Open Controls",
    
    // Taxes
    taxes: "Taxes",
    taxEstimator: "AI Tax Estimator",
    
    // AI Assistant
    aiAssistant: "VillaPilot AI",
    aiAssistantSubtitle: "Your property co-pilot",
    aiChatPlaceholder: "Ask me anything about your property...",
    aiThinking: "Thinking...",
    aiDisclaimer: "AI assistant. Not financial or legal advice.",
    clearChat: "Clear chat",
    
    // Marketing - Features Section
    featuresTitle: "Everything you need to manage luxury properties",
    featuresSubtitle: "Built specifically for high-end vacation villas and rental properties",
    featureFinancialTitle: "Financial Control",
    featureFinancialDesc: "Real-time expense tracking, operating accounts, and complete financial transparency for property owners.",
    featureAITitle: "AI Intelligence",
    featureAIDesc: "Claude Sonnet 4.5 powered assistant providing instant insights, property valuations, and market analysis.",
    featureMultiRoleTitle: "Multi-Role Platform",
    featureMultiRoleDesc: "Separate dashboards for owners, managers, and vendors with role-based permissions.",
    featureSecurityTitle: "Enterprise Security",
    featureSecurityDesc: "Bank-level encryption, JWT authentication, and complete data privacy for your properties.",
    featureRealtimeTitle: "Real-Time Updates",
    featureRealtimeDesc: "Instant notifications for expense approvals, maintenance alerts, and property updates.",
    featureOperationsTitle: "Complete Operations",
    featureOperationsDesc: "Maintenance tickets, inventory tracking, vendor management, all in one platform.",
    
    // Marketing - How it Works
    getStartedInMinutes: "Get started in minutes",
    stepCreateAccount: "Create Account",
    stepCreateAccountDesc: "Sign up and add your properties in under 2 minutes",
    stepInviteTeam: "Invite Your Team",
    stepInviteTeamDesc: "Add managers and vendors with role-based access",
    stepStartManaging: "Start Managing",
    stepStartManagingDesc: "Track expenses, maintenance, and get AI insights instantly",
    
    // Marketing - Pricing
    pricingTitle: "Simple, transparent pricing",
    pricingSubtitle: "Choose the plan that fits your portfolio",
    mostPopular: "Most Popular",
    
    // Marketing - Testimonials
    testimonialsTitle: "Trusted by property owners worldwide",
    
    // Marketing - CTA Section
    ctaTitle: "Ready to transform your property management?",
    ctaSubtitle: "Built for luxury villa owners who want clarity, control, and calm. Less spreadsheets. More sunsets.",
    startFreeTrial: "Get Started Now",
    trialInfo: "14-day free trial • Secure checkout with Stripe",
    
    // Marketing - Footer
    footerTagline: "Intelligence for luxury properties",
    product: "Product",
    mobileApp: "Mobile App",
    company: "Company",
    about: "About",
    careers: "Careers",
    legal: "Legal",
    privacy: "Privacy",
    terms: "Terms",
    security: "Security",
    footerCopyright: "Built for luxury property excellence.",
  },
  
  es: {
    // Auth
    welcome: "Bienvenido",
    signIn: "Iniciar Sesión",
    signUp: "Registrarse",
    email: "Correo Electrónico",
    password: "Contraseña",
    fullName: "Nombre Completo",
    role: "Rol",
    owner: "Propietario",
    manager: "Administrador",
    login: "Ingresar",
    register: "Registrarse",
    noAccount: "¿No tienes cuenta?",
    haveAccount: "¿Ya tienes cuenta?",
    
    // Navigation
    overview: "Resumen",
    myProperties: "Mis Propiedades",
    properties: "Propiedades",
    expenses: "Gastos",
    maintenance: "Mantenimiento",
    visualInventory: "Inventario Visual",
    aiInventory: "AI Inventario",
    reports: "Reportes",
    managers: "Administradores",
    aiValuation: "AI Valuación",
    marketData: "Datos de Mercado",
    subscription: "Suscripción",
    aiCFO: "AI CFO",
    logout: "Cerrar Sesión",
    
    // Dashboard
    controlTower: "Torre de Control",
    propertyIntelligence: "Inteligencia de Propiedad con AI",
    operatingBalance: "Balance Operativo",
    monthlyExpenses: "Gastos Mensuales",
    netOperatingIncome: "Ingreso Neto Operativo",
    propertyHealth: "Salud de Propiedad",
    
    // Inventory
    totalInventoryValue: "Valor Total Inventario",
    items: "artículos",
    goodCondition: "Buen Estado",
    needsAttention: "Requiere Atención",
    itemsToReview: "artículos a revisar",
    quickActions: "Acciones Rápidas",
    viewInventory: "Ver Inventario",
    itemsNeedingAttention: "Artículos que Requieren Atención",
    needsReplacement: "Necesita reemplazo",
    poorCondition: "Estado pobre",
    
    // CFO Dashboard
    aiPropertyCFO: "AI Property CFO",
    completeFinancialControl: "Control financiero completo de tu propiedad",
    addIncome: "Agregar Ingreso",
    configure: "Configurar",
    income: "Ingresos",
    totalExpenses: "Gastos Totales",
    cashFlow: "Flujo de Caja",
    annualROI: "ROI Anual",
    margin: "Margen",
    bookings: "reservas",
    nights: "noches",
    propertyValue: "Valor Propiedad",
    
    // Dashboard Stats
    occupancy: "Ocupación",
    thisYear: "Este año",
    profit: "Ganancia",
    loss: "Pérdida",
    annualAverage: "Promedio anual",
    months12: "12 meses",
    balance: "Balance",
    
    // Budget
    smartBudgetAutopilot: "Smart Budget Autopilot",
    annualBudget: "Presupuesto Anual",
    used: "usado",
    remaining: "Restante",
    projectedAnnual: "Proyección Anual",
    monthlyBudgetRemaining: "Presupuesto mensual restante",
    budgetOnTrack: "Presupuesto en buen estado",
    budgetExceeded: "¡Presupuesto excedido!",
    
    // Reports
    reportHistory: "Historial de Reportes",
    generateAndManageReports: "Genera y administra todos tus reportes financieros e inventario",
    financialPDF: "Financiero PDF",
    financialExcel: "Financiero Excel",
    sale: "Venta",
    allReports: "Todos",
    noReports: "Sin reportes",
    generateFirstReport: "Genera tu primer reporte usando los botones de arriba",
    totalReports: "Total Reportes",
    
    // Subscription
    subscriptionPlans: "Planes de Suscripción",
    choosePerfectPlan: "Elige el plan perfecto para gestionar tus propiedades de lujo con IA",
    yourPlan: "TU PLAN",
    subscribe: "Suscribirse",
    currentPlan: "Plan Actual",
    cancelSubscription: "Cancelar Suscripción",
    planActive: "Plan Activo",
    subscriptionActive: "Tu suscripción está activa",
    
    // Plans
    basicPlan: "Básico",
    basicDescription: "Control básico de tu propiedad",
    proPlan: "Pro",
    proDescription: "Control inteligente con AI",
    premiumPlan: "Premium",
    premiumDescription: "Suite completa de gestión",
    
    // Features
    oneProperty: "1 Propiedad",
    upTo3Properties: "Hasta 3 Propiedades",
    unlimitedProperties: "Propiedades Ilimitadas",
    expenseTracking: "Seguimiento de gastos",
    basicInventory: "Inventario básico",
    financialReports: "Reportes financieros PDF/Excel",
    aiPropertyCFOFeature: "AI Property CFO",
    smartBudgetFeature: "Smart Budget Autopilot",
    aiValuationFeature: "AI Valuación",
    visualInventoryAI: "Inventario Visual con AI",
    insuranceReports: "Reportes de Seguros",
    aiPropertyAdvisor: "AI Property Advisor",
    vendorNetwork: "Red de Proveedores",
    rentalOptimization: "Optimización de Rentals",
    prioritySupport: "Soporte Prioritario",
    apiAccess: "Acceso API",
    
    // AI Assistant
    aiInventoryAssistant: "Asistente AI de Inventario",
    analyzeInventoryWithAI: "Analiza y comprende tu inventario con inteligencia artificial",
    askAboutInventory: "Pregunta sobre tu inventario...",
    quickQuestions: "Preguntas Rápidas",
    needsReplacementQ: "¿Qué artículos necesitan reemplazo pronto?",
    conditionSummary: "Dame un resumen de la condición general del inventario",
    highestValueCategory: "¿Qué categorías tienen más valor?",
    mostValuableItems: "¿Cuáles son los artículos más valiosos?",
    recommendImprovements: "Recomienda mejoras para el inventario",
    inventorySummary: "Resumen del Inventario",
    locations: "Ubicaciones",
    aiDetected: "Detectados por AI",
    byCondition: "Por Condición",
    excellent: "Excelente",
    good: "Bueno",
    fair: "Regular",
    poor: "Malo",
    
    // Common
    loading: "Cargando...",
    error: "Error",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    download: "Descargar",
    generate: "Generar",
    refresh: "Actualizar",
    filter: "Filtrar",
    search: "Buscar",
    noData: "Sin datos",
    selectedProperty: "Propiedad Seleccionada",
    name: "Nombre",
    location: "Ubicación",
    health: "Salud",
    ticketsAndTasks: "Tickets y tareas",
    pdfExcelReports: "Reportes PDF, Excel",
    
    // Month abbreviations
    jan: "Ene",
    feb: "Feb",
    mar: "Mar",
    apr: "Abr",
    may: "May",
    jun: "Jun",
    jul: "Jul",
    aug: "Ago",
    sep: "Sep",
    oct: "Oct",
    nov: "Nov",
    dec: "Dic",
    
    // Visual Inventory
    aiPoweredInventory: "Inventario de propiedad con AI y fotos",
    downloadReport: "Descargar Reporte",
    addLocation: "Agregar Ubicación",
    newLocation: "Nueva Ubicación",
    locationPlaceholder: "ej., Cocina, Sala, Dormitorio Principal",
    createLocation: "Crear Ubicación",
    uploadPhotos: "Subir Fotos",
    analyzing: "Analizando...",
    noPhotosYet: "Sin fotos aún. Sube fotos para iniciar el inventario.",
    photoDetails: "Detalles de la Foto",
    category: "Categoría",
    description: "Descripción",
    identifiedItems: "Artículos Identificados",
    brand: "Marca",
    type: "Tipo",
    condition: "Condición",
    yourNotes: "Tus Notas",
    deletePhoto: "Eliminar Foto",
    
    // Concierge Network
    concierge: "Concierge",
    conciergeNetwork: "Red Concierge",
    connectWithProviders: "Conecta con proveedores de servicios de confianza para tus propiedades",
    browseVendors: "Buscar Proveedores",
    myQuotes: "Mis Cotizaciones",
    myContracts: "Mis Contratos",
    searchVendors: "Buscar proveedores...",
    categories: "Categorías",
    allCategories: "Todas",
    noVendorsFound: "No se encontraron proveedores",
    reviews: "Reseñas",
    jobsCompleted: "trabajos completados",
    services: "Servicios",
    requestQuote: "Solicitar Cotización",
    
    // Demo Modal
    liveDemo: "DEMO EN VIVO",
    seeVillaPilotInAction: "Ve VillaPilot AI en Acción",
    exploreRealDemoProperty: "Explora una propiedad demo real con 12 meses de datos",
    beds: "camas",
    baths: "baños",
    openControlTower: "Abrir Torre de Control",
    controlTowerManageProperty: "Torre de Control - Administra Tu Propiedad",
    allToolsNeeded: "Todas las herramientas que necesitas para gestionar tu propiedad de lujo",
    projections: "Proyecciones",
    smartAlerts: "Alertas inteligentes",
    trackIncome: "Registrar ingresos",
    categorize: "Categorizar",
    setBudgets: "Definir presupuestos",
    scheduleTasks: "Programar tareas",
    trackRepairs: "Seguir reparaciones",
    history: "Historial",
    photoScanning: "Escaneo de fotos",
    aiRecognition: "Reconocimiento IA",
    damageReports: "Reportes de daños",
    financial: "Financiero",
    resale: "Reventa",
    vendorDirectory: "Directorio de proveedores",
    requestQuotes: "Solicitar cotizaciones",
    monthPerformance12: "Rendimiento de 12 Meses",
    value: "Valor",
    tryWithYourProperty: "Pruébalo Con Tu Propiedad",
    
    requestingQuoteFrom: "Solicitando cotización de",
    title: "Título",
    briefTitle: "Título breve para tu solicitud",
    describeWork: "Describe el trabajo necesario...",
    preferredDate: "Fecha Preferida",
    budgetRange: "Rango de Presupuesto",
    selectBudget: "Seleccionar presupuesto",
    sendQuoteRequest: "Enviar Solicitud",
    quoteRequestSent: "Solicitud de cotización enviada",
    failedToSendQuote: "Error al enviar cotización",
    noQuotesYet: "Sin cotizaciones aún. Busca proveedores para solicitar.",
    quoteAmount: "Monto de Cotización",
    accept: "Aceptar",
    quoteAccepted: "¡Cotización aceptada! Contrato creado.",
    quoteRejected: "Cotización rechazada",
    failedToAcceptQuote: "Error al aceptar cotización",
    failedToRejectQuote: "Error al rechazar cotización",
    noContractsYet: "Sin contratos aún",
    contractAmount: "Monto del Contrato",
    scheduledDate: "Fecha Programada",
    payNow: "Pagar Ahora",
    markComplete: "Marcar Completo",
    paymentSuccessful: "¡Pago exitoso!",
    failedToProcessPayment: "Error al procesar pago",
    contractCompleted: "Contrato marcado como completado",
    failedToCompleteContract: "Error al completar contrato",
    quoted: "Cotizado",
    accepted: "Aceptado",
    active: "Activo",
    completed: "Completado",
    cancelled: "Cancelado",
    paid: "Pagado",
    pendingPayment: "Pago Pendiente",
    
    // Marketing
    getStarted: "Comenzar",
    learnMore: "Saber Más",
    features: "Características",
    pricing: "Precios",
    contact: "Contacto",
    
    // Trust badges
    securePayments: "Pagos seguros con Stripe",
    cancelAnytime: "Cancela cuando quieras",
    instantActivation: "Activación instantánea",
    
    // FAQ
    faq: "Preguntas Frecuentes",
    canChangePlan: "¿Puedo cambiar de plan después?",
    canChangePlanAnswer: "Sí, puedes actualizar o degradar tu plan en cualquier momento. Los cambios se aplicarán al inicio del siguiente período de facturación.",
    paymentMethods: "¿Qué métodos de pago aceptan?",
    paymentMethodsAnswer: "Aceptamos todas las tarjetas de crédito y débito principales a través de Stripe: Visa, Mastercard, American Express.",
    moneyBackGuarantee: "¿Hay prueba gratuita?",
    moneyBackGuaranteeAnswer: "Sí — cada plan de pago comienza con una prueba gratuita de 14 días. No se te cobra hasta que termina la prueba, y puedes cancelar en cualquier momento antes de eso sin costo.",
    
    // Navigation Labels
    calendars: "Calendarios",
    inventory: "Inventario",
    selectLanguage: "Idioma",
    
    // Marketing/Landing Page
    heroTitle: "Gestión de Propiedades",
    heroSubtitle: "Reinventada con IA",
    heroDescription: "La plataforma más inteligente para la gestión de villas de lujo. Control operativo completo, transparencia financiera e insights impulsados por IA.",
    watchDemo: "Ver Demo",
    requestDemo: "Solicitar Demo",
    talkToSales: "Hablar con Ventas",
    trialNote: "Prueba gratuita de 14 días • Pago seguro con Stripe",
    propertiesManaged: "Propiedades Gestionadas",
    assetsUnderManagement: "Activos Bajo Gestión",
    customerSatisfaction: "Satisfacción del Cliente",
    countries: "Países",
    howItWorks: "Cómo Funciona",
    testimonials: "Testimonios",
    
    // Control Tower - Cards
    financialDashboard: "Dashboard financiero",
    syncPlatforms: "Sincronizar plataformas",
    registerExpenses: "Registrar gastos",
    manageItems: "Gestionar items",
    scanWithPhotos: "Escanear con fotos",
    priceAlerts: "Alertas Precios",
    vendorContracts: "Contratos proveedores",
    providerNetwork: "Red de proveedores",
    generatePdfExcel: "Generar PDF/Excel",
    inventoryChat: "Chat Inventario",
    expensesLabel: "Gastos",
    
    // Property Card
    selectProperty: "Selecciona una propiedad para ver su Torre de Control completa",
    bedrooms: "habitaciones",
    bathrooms: "baños",
    addFirstProperty: "Agrega tu primera propiedad",
    demoPropertyHelp: "La propiedad demo te muestra todas las funcionalidades. ¡Agrega tu villa real para comenzar!",
    addProperty: "Agregar Propiedad",
    incomeVsExpenses: "Ingresos vs Gastos",
    monthlyOccupancy: "Ocupación Mensual",
    
    // Dashboard specific
    currentParameters: "Parámetros Actuales",
    investmentSummary: "Resumen de Inversión",
    estimatedValue: "Valor Estimado",
    appreciation: "Plusvalía",
    netIncome: "Ingreso Neto",
    
    // Vendor Tasks
    myTasks: "Mis Tareas",
    completedTasks: "Completadas",
    
    // Calendar Sync
    calendarSync: "Sincronización de Calendarios",
    connectCalendars: "Conecta tus calendarios de Airbnb, VRBO y otras plataformas",
    syncAll: "Sincronizar Todo",
    addCalendar: "Agregar Calendario",
    connectedCalendars: "Calendarios Conectados",
    noCalendarsConnected: "No hay calendarios conectados",
    addFirstCalendar: "Agregar tu primer calendario",
    syncedBookings: "Reservas Sincronizadas",
    upcomingBookings: "Próximas Reservas",
    totalNights: "noches totales",
    platform: "Plataforma",
    lastSync: "Última sync",
    syncCompleted: "Sincronización completada",
    blocked: "Bloqueado",
    booking: "Reserva",
    confirmed: "Confirmada",
    night: "noche",
    addIcalCalendar: "Agregar Calendario iCal",
    calendarName: "Nombre del calendario",
    icalUrl: "URL del calendario iCal",
    validateCalendar: "Validando...",
    whereToFindUrl: "¿Dónde encuentro la URL?",
    airbnbHelp: "En Airbnb: Ve a tu Calendario → Configuración (⚙️) → \"Exportar calendario\" → Copia el enlace iCal",
    
    // Expenses
    expensesAndIncome: "Gastos e Ingresos",
    manageExpenses: "Gestiona y aprueba los gastos de tus propiedades",
    newExpense: "Nuevo Gasto",
    pending: "Pendiente",
    approved: "Aprobado",
    rejected: "Rechazado",
    pendingApproval: "Pendientes de Aprobación",
    allExpenses: "Todos los Gastos",
    date: "Fecha",
    vendor: "Proveedor",
    amount: "Monto",
    status: "Estado",
    approve: "Aprobar",
    reject: "Rechazar",
    registerNewExpense: "Registrar Nuevo Gasto",
    selectCategory: "Seleccionar categoría...",
    selectSubcategory: "Seleccionar subcategoría...",
    amountUSD: "Monto (USD)",
    providerVendor: "Proveedor / Vendor",
    providerName: "Nombre del proveedor",
    expenseDescription: "Descripción",
    additionalDescription: "Descripción adicional del gasto...",
    invoiceReceipt: "Factura / Recibo (opcional)",
    clickToUpload: "Haz clic para subir una imagen o PDF",
    registerExpense: "Registrar Gasto",
    saving: "Guardando...",
    property: "Propiedad",
    
    // Expense Subcategories
    electricity: "Electricidad",
    water: "Agua",
    internet: "Internet",
    gas: "Gas",
    cableTV: "Cable/TV",
    phone: "Teléfono",
    regularCleaning: "Limpieza Regular",
    deepCleaning: "Limpieza Profunda",
    laundry: "Lavandería",
    suppliesSub: "Suministros",
    ac: "A/C",
    plumbing: "Plomería",
    electricalWork: "Electricidad",
    painting: "Pintura",
    general: "General",
    insurance: "Seguro",
    taxesSub: "Impuestos",
    accounting: "Contabilidad",
    licenses: "Licencias",
    furniture: "Mobiliario",
    appliances: "Electrodomésticos",
    improvements: "Mejoras",
    remodeling: "Remodelación",
    amenities: "Amenities",
    bathroomItems: "Artículos de baño",
    kitchen: "Cocina",
    office: "Oficina",
    
    // Inventory Management
    inventoryManagement: "Gestión de Inventario",
    manageAllItems: "Administra todos los items de tu propiedad",
    addItem: "Agregar Item",
    totalItems: "Items Totales",
    totalValue: "Valor Total",
    differentTypes: "tipos diferentes",
    searchByName: "Buscar por nombre...",
    allCategoriesFilter: "Todas las categorías",
    sortByName: "Nombre",
    sortByValue: "Valor",
    sortByCategory: "Categoría",
    noItemsFound: "No se encontraron items con esos filtros",
    noItemsInInventory: "No hay items en el inventario",
    addFirstItem: "Agregar primer item",
    quantity: "Cantidad",
    unitValue: "Valor unitario",
    editItem: "Editar Item",
    categoryRequired: "Categoría",
    itemName: "Nombre del Item",
    estimatedValueLabel: "Valor Estimado ($)",
    purchaseDateOptional: "Fecha de Compra (opcional)",
    replacementCycle: "Ciclo de Reemplazo (meses)",
    replacementCycleHelp: "Frecuencia estimada para reemplazar este item",
    notesOptional: "Notas (opcional)",
    additionalInfo: "Información adicional sobre el item...",
    updateItem: "Actualizar Item",
    
    // CFO Dashboard
    registerRentalIncome: "Registrar Ingreso por Alquiler",
    source: "Fuente",
    directBooking: "Reserva Directa",
    guestNameOptional: "Nombre del Huésped (opcional)",
    checkIn: "Check-in",
    checkOut: "Check-out",
    nightlyRate: "Tarifa por Noche ($)",
    platformFee: "Fee Plataforma ($)",
    cleaningFee: "Fee Limpieza ($)",
    cfoSettings: "Configuración CFO",
    estimatedPropertyValue: "Valor Estimado de la Propiedad ($)",
    purchasePrice: "Precio de Compra ($)",
    annualMaintenanceBudget: "Presupuesto Anual de Mantenimiento ($)",
    budgetAlertThreshold: "Alerta de Presupuesto (%)",
    budgetAlertHelp: "Recibir alerta cuando se use este % del presupuesto",
    saveSettings: "Guardar Configuración",
    settings: "Configurar",
    incomeVsExpensesMonthly: "Ingresos vs Gastos Mensuales",
    incomeBySource: "Ingresos por Fuente",
    noIncomeData: "Sin datos de ingresos",
    expensesByCategory: "Gastos por Categoría",
    noExpenseData: "Sin datos de gastos",
    occupancyLabel: "Ocupación",
    nightsRented: "noches rentadas",
    averageRate: "Tarifa Promedio",
    perNight: "por noche",
    propertyValueLabel: "Valor Propiedad",
    purchase: "Compra",
    subcategory: "Subcategoría",
    confirmDeleteCalendar: "¿Eliminar este calendario y todas sus reservas sincronizadas?",
    success: "Éxito",
    calendarDeleted: "Calendario eliminado",
    deleteError: "No se pudo eliminar",
    calendarsSynced: "calendarios sincronizados",
    syncError: "Error al sincronizar",
    registerAndApprove: "Registrar y aprobar gastos",
    loadPropertiesError: "No se pudieron cargar las propiedades",
    nameUrlRequired: "Nombre y URL son requeridos",
    calendarAdded: "Calendario agregado correctamente",
    syncing: "Sincronizando...",
    fetchingBookings: "Obteniendo reservas del calendario",
    addCalendarError: "No se pudo agregar el calendario",
    newBookings: "nuevas",
    updatedBookings: "actualizadas",
    incomeRegistered: "Ingreso registrado correctamente",
    incomeRegisterError: "No se pudo registrar el ingreso",
    settingsUpdated: "Configuración actualizada",
    settingsUpdateError: "No se pudo actualizar la configuración",
    updateExpenseError: "No se pudo actualizar el gasto",
    expense: "Gasto",
    pdfDownloaded: "Reporte PDF descargado",
    pdfGenerateError: "Error al generar PDF",
    excelDownloaded: "Reporte Excel descargado",
    excelGenerateError: "Error al generar Excel",
    
    // Vendor Contracts Page
    vendorContractsTitle: "Contratos de Proveedores",
    vendorContractsDescription: "Gestiona los contratos con tus proveedores y recibe alertas si te cobran de más",
    contracts: "Contratos",
    alerts: "Alertas",
    activeAlerts: "alertas activas",
    potentialOvercharge: "Posible sobrecargo total",
    viewAlerts: "Ver alertas",
    addContract: "Agregar Contrato",
    noContractsRegistered: "Sin contratos registrados",
    registerContractsHelp: "Registra los precios acordados con tus proveedores para recibir alertas si te cobran de más",
    addFirstContract: "Agregar primer contrato",
    perService: "servicio",
    perHour: "hora",
    perMonth: "mes",
    validUntil: "Válido hasta",
    noActiveAlerts: "Sin alertas activas",
    allExpensesWithinPrices: "Todos los gastos están dentro de los precios acordados con los proveedores",
    charged: "Cobrado",
    expected: "Esperado",
    excess: "exceso",
    recommendation: "Recomendación",
    newContract: "Nuevo Contrato",
    vendorNameLabel: "Nombre del Proveedor",
    vendorNamePlaceholder: "Ej: Juan Pérez Limpieza",
    categoryLabel: "Categoría",
    typeLabel: "Tipo",
    quote: "Cotización",
    contract: "Contrato",
    invoice: "Factura",
    agreedRates: "Tarifas Acordadas",
    perServiceRate: "Por Servicio",
    hourlyRate: "Por Hora",
    monthlyRate: "Mensual",
    descriptionLabel: "Descripción",
    serviceDetails: "Detalles del servicio...",
    validUntilLabel: "Válido Hasta",
    cancelButton: "Cancelar",
    saveContract: "Guardar Contrato",
    contractSaved: "Contrato guardado",
    contractSavedDesc: "El contrato del proveedor se ha registrado correctamente",
    contractDeleted: "Contrato eliminado",
    deleteContract: "¿Eliminar este contrato?",
    alertDismissed: "Alerta descartada",
    
    // Categories
    cleaning: "Limpieza",
    maintenanceCat: "Mantenimiento",
    pool: "Piscina",
    garden: "Jardinería",
    utilities: "Servicios",
    other: "Otro",
    
    // Report types
    financialReportPdf: "Reporte Financiero PDF",
    financialReportExcel: "Reporte Financiero Excel",
    visualInventoryReport: "Inventario Visual",
    insuranceReport: "Reporte Seguros",
    saleReport: "Reporte Venta",
    downloaded: "Descargado",
    deleted: "Eliminado",
    reportDeletedFromHistory: "Reporte eliminado del historial",
    deleteReportConfirm: "¿Estás seguro de eliminar este reporte?",
    
    // Demo banner
    demoBanner: "Esta es una propiedad de demostración con datos de 1 año. ¡Explora todas las funcionalidades que VillaPilot AI ofrece para gestionar tus propiedades!",
    
    // Charts
    incomeSources: "Fuentes de Ingresos",
    expenseBreakdown: "Desglose de Gastos",
    recentExpenses: "Gastos Recientes",
    viewAll: "Ver todos",
    noRecentExpenses: "No hay gastos recientes",
    upcomingBookingsLabel: "Próximas Reservas",
    noUpcomingBookings: "No hay próximas reservas",
    startRecordingData: "Comienza a registrar datos",
    chartsAppearWhen: "Los gráficos aparecerán cuando registres ingresos, gastos o conectes tus calendarios de Airbnb/VRBO.",
    registerIncome: "Registrar Ingreso",
    connectCalendar: "Conectar Calendario",
    loadingData: "Cargando datos...",
    annualIncome: "Ingresos Anuales",
    annualExpenses: "Gastos Anuales",
    annualNetIncome: "Ingreso Neto Anual",
    
    // Open Controls
    openControls: "Abrir Controles",
    
    // Taxes
    taxes: "Impuestos",
    taxEstimator: "Estimador IA",
    
    // AI Assistant
    aiAssistant: "VillaPilot AI",
    aiAssistantSubtitle: "Tu copiloto de propiedades",
    aiChatPlaceholder: "Pregúntame sobre tu propiedad...",
    aiThinking: "Pensando...",
    aiDisclaimer: "Asistente IA. No es asesoría financiera ni legal.",
    clearChat: "Limpiar chat",
    
    // Marketing - Features Section
    featuresTitle: "Todo lo que necesitas para gestionar propiedades de lujo",
    featuresSubtitle: "Diseñado específicamente para villas vacacionales y propiedades de alquiler premium",
    featureFinancialTitle: "Control Financiero",
    featureFinancialDesc: "Seguimiento de gastos en tiempo real, cuentas operativas y transparencia financiera completa para propietarios.",
    featureAITitle: "Inteligencia Artificial",
    featureAIDesc: "Asistente con Claude Sonnet 4.5 que proporciona insights instantáneos, valuaciones de propiedades y análisis de mercado.",
    featureMultiRoleTitle: "Plataforma Multi-Rol",
    featureMultiRoleDesc: "Dashboards separados para propietarios, administradores y proveedores con permisos basados en roles.",
    featureSecurityTitle: "Seguridad Empresarial",
    featureSecurityDesc: "Encriptación de nivel bancario, autenticación JWT y privacidad total de datos para tus propiedades.",
    featureRealtimeTitle: "Actualizaciones en Tiempo Real",
    featureRealtimeDesc: "Notificaciones instantáneas para aprobaciones de gastos, alertas de mantenimiento y actualizaciones de propiedad.",
    featureOperationsTitle: "Operaciones Completas",
    featureOperationsDesc: "Tickets de mantenimiento, seguimiento de inventario, gestión de proveedores, todo en una plataforma.",
    
    // Marketing - How it Works
    getStartedInMinutes: "Comienza en minutos",
    stepCreateAccount: "Crea tu Cuenta",
    stepCreateAccountDesc: "Regístrate y agrega tus propiedades en menos de 2 minutos",
    stepInviteTeam: "Invita a tu Equipo",
    stepInviteTeamDesc: "Agrega administradores y proveedores con acceso basado en roles",
    stepStartManaging: "Empieza a Gestionar",
    stepStartManagingDesc: "Rastrea gastos, mantenimiento y obtén insights de IA instantáneamente",
    
    // Marketing - Pricing
    pricingTitle: "Precios simples y transparentes",
    pricingSubtitle: "Elige el plan que se ajuste a tu portafolio",
    mostPopular: "Más Popular",
    
    // Marketing - Testimonials
    testimonialsTitle: "Confiado por propietarios en todo el mundo",
    
    // Marketing - CTA Section
    ctaTitle: "¿Listo para transformar la gestión de tu propiedad?",
    ctaSubtitle: "Diseñado para dueños de villas de lujo que buscan claridad, control y tranquilidad. Menos hojas de cálculo. Más atardeceres.",
    startFreeTrial: "Comenzar Ahora",
    trialInfo: "Prueba gratuita de 14 días • Pago seguro con Stripe",
    
    // Marketing - Footer
    footerTagline: "Inteligencia para propiedades de lujo",
    product: "Producto",
    mobileApp: "App Móvil",
    company: "Empresa",
    about: "Nosotros",
    careers: "Empleos",
    legal: "Legal",
    privacy: "Privacidad",
    terms: "Términos",
    security: "Seguridad",
    footerCopyright: "Construido para la excelencia en propiedades de lujo.",
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('villapilot_language');
    return saved || 'en';
  });

  useEffect(() => {
    localStorage.setItem('villapilot_language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'es' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
